export const MESSAGE_PLACEHOLDER_SELECT_MENU = "Taper pour filtrer...";
export const MESSAGE_PLACEHOLDER_CHOIX_DATE = "Sélectionner une date";
export const MESSAGE_PLACEHOLDER_NOM = "Jean Dupont";
export const MESSAGE_PLACEHOLDER_EMAIL = "jean.dupont@domaine.fr";
export const MESSAGE_PLACEHOLDER_TELEPHONE = "0123456789";
